














import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Language from '@/language/Language';
import LanguageFactory from '@/language/LanguageFactory';

@Component
export default class LanguagePicker extends Vue {
    @Prop({ type: Object, required: true })
    value!: Language;

    private languageFactory!: LanguageFactory;

    private created(): void {
        this.languageFactory = new LanguageFactory();
    }

    private get languages(): Array<Language> {
        return this.languageFactory.list();
    }

    private isActive(language: Language): boolean {
        return language.code === this.value.code;
    }

    @Emit('input')
    private languagePicked(language: Language): Language {
        return language;
    }
}
